module.exports = __webpack_public_path__ + "img/usdt.ee88a860.png";